<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-container>
            <v-row>
                <v-col>
                    <v-card class="elevation-6">
                        <v-row>
                            <v-col class="pb-0">
                                <v-card-text>
                                    <v-toolbar color="white" flat>
                                        <v-toolbar-title>Παραγγελίες Βιβλιοθηκών</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-speed-dial
                                                class="mb-8"
                                                color="primary" dark direction="left" fab open-on-hover
                                                right
                                                top
                                                v-model="fab">
                                            <template v-slot:activator>
                                                <v-btn color="primary"
                                                       dark
                                                       fab
                                                       small
                                                       v-model="fab">
                                                    <v-icon v-if="fab">mdi-close</v-icon>
                                                    <v-icon v-else>add</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn @click="openDatePicker(false)"
                                                           color="primary"
                                                           dark
                                                           fab
                                                           small
                                                           v-on="on">
                                                        <v-icon>get_app</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Παραδόσεις Βιβλίων σε Βιβλιοθήκες</span>
                                            </v-tooltip>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn @click="openDatePicker(true)"
                                                           color="primary"
                                                           dark
                                                           fab
                                                           small
                                                           v-on="on">
                                                        <v-icon>system_update_alt</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Παραγγελίες Βιβλίων από Βιβλιοθήκες</span>
                                            </v-tooltip>
                                        </v-speed-dial>
                                    </v-toolbar>
                                    <v-divider></v-divider>
                                </v-card-text>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-card class="mx-3" overlined>

                                    <v-row>
                                        <v-col cols="12" lg="6" md="6" sm="12">
                                            <v-text-field
                                                    append-icon="search"
                                                    class="ml-4"
                                                    hide-details
                                                    label="Αναζήτηση"
                                                    single-line
                                                    v-model="search"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" lg="6" md="6" sm="12">
                                            <v-select :items="selectItems"
                                                      @change="getAllLibraryOrder(true)"
                                                      class="mt-3 mr-4"
                                                      dense
                                                      item-text="label"
                                                      label="Ακαδημαϊκό Έτος"
                                                      outlined
                                                      return-object
                                                      v-model="academicYearSelect"
                                            ></v-select>
                                        </v-col>
                                    </v-row>

                                    <v-data-table
                                            :headers="headers"
                                            :items="$store.getters.libraryOrder"
                                            :search="search"
                                            fixed-header
                                            no-data-text="Δεν υπάρχουν δεδομένα.">

                                        <template v-slot:item="{ item }">
                                            <tr>
                                                <td @click="getAction(item)" class="text-center d-sm-table-cell d-flex">
                                                    {{ item.institutionName }}
                                                </td>
                                                <td @click="getAction(item)" class="text-center d-sm-table-cell d-flex">
                                                    {{ item.libraryName }}
                                                </td>
                                                <td @click="getAction(item)" class="text-center d-sm-table-cell d-flex">
                                                    {{ item.bookId}}
                                                </td>
                                                <td @click="getAction(item)" class="text-center d-sm-table-cell d-flex">
                                                    {{ item.bookTitle}}
                                                </td>
                                                <td @click="getAction(item)" class="text-center d-sm-table-cell d-flex">
                                                    {{ item.amount}}
                                                </td>
                                                <td @click="getAction(item)" class="text-center d-sm-table-cell d-flex">
                                                    {{ status(item.status)}}
                                                </td>
                                                <td @click="getAction(item)" class="text-center d-sm-table-cell d-flex">
                                                    {{ returnTheDate(item.statusDate)}}
                                                </td>
                                                <td class="text-center d-sm-table-cell d-flex">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon @click="getinfo(item)" color="info" v-on="on">info
                                                            </v-icon>
                                                        </template>
                                                        <span>Στοιχεία Επικοινωνίας</span>
                                                    </v-tooltip>
                                                  <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                      <v-icon @click="printReceiptOrder(item.id)" color="primary" v-on="on">mdi-printer
                                                      </v-icon>
                                                    </template>
                                                    <span>Εκτύπωση παραγγελίας</span>
                                                  </v-tooltip>
                                                  <v-tooltip v-if="completionEnabled(item)" top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                      <v-icon @click="completeButton(item)" color="primary" v-on="on">mdi-check
                                                      </v-icon>
                                                    </template>
                                                    <span>Ολοκλήρωση παραγγελίας</span>
                                                  </v-tooltip>
                                                  <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                      <v-icon @click="cancelButton(item)" color="red" v-on="on">mdi-cancel
                                                      </v-icon>
                                                    </template>
                                                    <span>Ακύρωση παραγγελίας</span>
                                                  </v-tooltip>
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>

            <LibraryInfoModal :libraryInfoObject="libraryInfoObject"/>
            <ActionLibraryOrder :libraryObject="libraryObject"/>


        </v-container>

        <div class="text-center">
            <v-dialog max-width="500"
                      persistent
                      scrollable
                      v-model="datePicker">
                <v-card flat>
                    <v-card-title class="headline primary white--text"
                                  primary-title>{{ordersOrDeliveries ? 'Παραγγελίες Βιβλίων από Βιβλιοθήκες' : 'Παραδόσεις Βιβλίων σε Βιβλιοθήκες'}}</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text style="height: 400px;" class="mt-4">
                        <v-date-picker :events="arrayEvents" :max="maxDate"
                                       :min="minDate"
                                       class="elevation-6"
                                       color="primary"
                                       first-day-of-week="1"
                                       full-width
                                       range
                                       locale="el"
                                       v-model="dates">

                        </v-date-picker>
                    </v-card-text>
                            <!--<v-stepper v-model="e1">-->
                                <!--<v-stepper-header>-->
                                    <!--<template v-for="n in steps">-->
                                        <!--<v-stepper-step-->
                                                <!--:complete="e1 > n"-->
                                                <!--:key="`${n}-step`"-->
                                                <!--:step="n"-->
                                                <!--editable>-->
                                            <!--{{returnStepName(n)}}-->
                                        <!--</v-stepper-step>-->

                                        <!--<v-divider-->
                                                <!--:key="n"-->
                                                <!--v-if="n !== steps"-->
                                        <!--&gt;</v-divider>-->
                                    <!--</template>-->
                                <!--</v-stepper-header>-->
                                <!--<v-stepper-items>-->
                                    <!--<v-stepper-content-->
                                            <!--key='1'-->
                                            <!--step="1">-->
                                        <!--<v-card-text style="height: 400px;" class="overflow-y-auto">-->
                                            <!--<v-radio-group v-if="institution.length > 0" v-model="dialogm1" @change="selectInstitutionForReport" column class="mt-0 pt-0">-->
                                                <!--<v-radio v-for="item in institution"-->
                                                         <!--:label="item.name"-->
                                                         <!--:value="item.selectedBookId"-->
                                                <!--class="my-2">-->
                                                <!--</v-radio>-->
                                            <!--</v-radio-group>-->
                                            <!--<div class="text-center" v-else>-->
                                                <!--<h2>Δεν υπάρχουν δεδομένα.</h2>-->
                                            <!--</div>-->
                                        <!--</v-card-text>-->
                                    <!--</v-stepper-content>-->
                                    <!--<v-stepper-content-->
                                            <!--key='2'-->
                                            <!--step="2">-->
                                        <!--<v-card-text style="height: 400px;">-->
                                        <!--<v-date-picker :events="arrayEvents" :max="maxDate"-->
                                                       <!--:min="minDate"-->
                                                       <!--class="elevation-6"-->
                                                       <!--color="primary"-->
                                                       <!--first-day-of-week="1"-->
                                                       <!--full-width-->
                                                       <!--range-->
                                                       <!--locale="el"-->
                                                       <!--v-model="dates">-->

                                        <!--</v-date-picker>-->
                                        <!--</v-card-text>-->
                                    <!--</v-stepper-content>-->
                                <!--</v-stepper-items>-->
                            <!--</v-stepper>-->
                    <v-card-actions>
                        <div class="flex-grow-1"></div>
                        <v-btn
                                @click="datePicker = false"
                                color="primary"
                                text>
                            Ακύρωση
                        </v-btn>
                        <v-btn  :loading=" ordersOrDeliveries ? $store.getters.publisherLibraryOrdersPdf.isLoading? true : false :  $store.getters.publisherLibraryOrdersDeliveredPdf.isLoading "
                                :disabled="dates.length > 0 ? false : true "
                                @click="getReportPdf"
                                color="primary"
                                text>
                            <v-icon>get_app</v-icon>pdf
                        </v-btn>
                        <v-btn :loading=" ordersOrDeliveries ? $store.getters.publisherLibraryOrdersXlsx.isLoading  ? true : false : $store.getters.publisherLibraryOrdersDeliveredXlsx.isLoading "
                               :disabled="dates.length > 0 ? false : true "
                               @click="getReportXlsx"
                               color="primary"
                               text>
                            <v-icon>get_app</v-icon>xlsx
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

          <v-dialog persistent max-width="550" v-model="cancelOrderDialog">
            <v-card style="background-color: #07575b" >
              <v-card-title class="justify-center "  >
                <span class="headline white--text"> Ακύρωση παραγγελίας </span>
              </v-card-title>
              <v-card-text style="background-color: rgb(212,213,210)">
                <h3 class="pt-4">Είστε σίγουροι ότι θέλετε να ακυρώσετε την παραγγελία για το σύγγραμμα με κωδικό {{libraryObject.bookId}};<br>Αυτή η ενέργεια δεν είναι αντιστρέψιμη.</h3>
              </v-card-text>
              <v-card-actions style="background-color: rgb(212,213,210)" class="justify-center pa-0 pb-2">

                <v-btn style="min-width: 150px" outlined @click="cancelOrderDialog = false"  color="primary" > Πίσω </v-btn>
                <v-btn style="min-width: 150px" @click="cancelOrder" color="red" >Ακύρωση</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog persistent max-width="550" v-model="completeOrderDialog">
            <v-card style="background-color: #07575b" >
              <v-card-title class="justify-center "  >
                <span class="headline white--text">Ολοκλήρωση παραγγελίας </span>
              </v-card-title>
              <v-card-text style="background-color: rgb(212,213,210)">
                <h3 class="pt-4">Για την ολοκλήρωση της παραγελίας εισάγετε τον αριθμό PIN που θα σας δώσει η
                  Βιβλιοθήκη και πατήστε 'Ολοκλήρωση'</h3>
                <v-row>
                  <v-col cols="4"></v-col>
                  <v-col cols="4">
                    <v-text-field
                      outlined
                      dense
                      color="primary"
                      placeholder="pin"
                      v-model="pin">
                    </v-text-field>
                  </v-col>
                  <v-col cols="4"></v-col>
                </v-row>
              </v-card-text>
              <v-card-actions style="background-color: rgb(212,213,210)" class="justify-center pa-0 pb-2">

                <v-btn style="min-width: 150px" outlined @click="completeOrderDialog = false"  color="primary" > Πίσω </v-btn>
                <v-btn style="min-width: 150px" @click="completeLibraryOrder" color="green" >Ολοκλήρωση</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
    </div>
</template>

<script>

    import utils from '../../utilities'
    import request from '../../requests'
    import LibraryInfoModal from "./LibraryInfoModal";
    import ActionLibraryOrder from "./ActionLibraryOrder";
    import service from "../../service";

    export default {
        name: "LibraryOrders",
        components: {ActionLibraryOrder, LibraryInfoModal},
        data: () => ({
            utils,
            cancelOrderDialog: false,
            completeOrderDialog: false,
            institution: [],
            institutionIdForReport: null,
            ordersOrDeliveries: false,
            dialogm1: '',
            e1: 1,
            steps: 2,
            fab: false,
            dates: [],
            datePicker: false,
            allReport: false,
            arrayEvents: [],
            minDate: '',
            maxDate: '',
            libraryObject: {},
            libraryInfoObject: {},
            selectItems: [],
            academicYearSelect: {},
            search: '',
            dialog: false,
            orderModal: false,
            pin: '',
            headers: [
                {
                    text: 'Ίδρυμα',
                    align: 'center',
                    value: 'institutionName',
                },
                {text: 'Βιβλιοθήκη', value: 'libraryName', align: 'center'},
                {text: 'Κωδικός', value: 'bookId', align: 'center', width: '100'},
                {text: 'Τίτλος', value: 'bookTitle', align: 'center'},
                {text: 'Τεμάχια', value: 'amount', align: 'center', width: '100'},
                {text: 'Κατάσταση', value: 'status', align: 'center'},
                {text: 'Ημερομηνία', value: 'statusDate', align: 'center', class: 'px-0'},
                {text: 'Ενέργειες', value: 'actions', align: 'center', width: '130', sortable: false}
            ],
        }),
        methods: {

            getAction(item) {
                // This dialog is obsolete and its functionality was moved to the last column of the table (eudoxus#140 - bullet 5)

                // this.libraryObject = item;
                // this.$store.commit('setActionLibraryModal', true);
            },

            printReceiptOrder(libraryOrderId) {
              let token = utils.getLocalStorage('token');
              if (token != null) {
                this.$store.commit('setLoadingModal', true);
                request.printReceiptOrder(token, libraryOrderId,  this.printReceiptOrderCallBack)
              } else {
                this.$store.commit('setloginModal', true);
              }
            },

          printReceiptOrderCallBack(response) {

            this.$store.commit('setLoadingModal', false);
            const file = new Blob(
                [response],
                {type: 'application/pdf'});

            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          },

          cancelButton(libraryOrder) {
              this.libraryObject = libraryOrder;
              this.cancelOrderDialog = true;
          },

          completeButton(libraryOrder) {
            this.libraryObject = libraryOrder;
            this.pin = '';
            this.completeOrderDialog = true;
          },

          cancelOrder() {
            this.$store.commit('setActionLibraryModal', false);
            let token = utils.getLocalStorage('token');
            if (token != null) {
              this.$store.commit('setLoadingModal', true);
              request.cancelLibraryOrder(token, this.libraryObject.id, this.cancelLibraryOrderCallBack, (resp) => this.cancelOrderDialog = false)
            } else {
              this.$store.commit('setloginModal', true);
            }
          },

          cancelLibraryOrderCallBack(response) {
              this.updateDataTable(response);
              this.cancelOrderDialog = false;
          },

          updateDataTable(response){

            this.pin = '';
            let libraryOrder =  this.$store.getters.libraryOrder;
            this.$store.commit('setLibraryOrder', []);
            for (var i = 0; i < libraryOrder.length; i++) {
              if (libraryOrder[i].id == response.id) {
                libraryOrder[i].status = response.status;
                libraryOrder[i].statusDate = response.statusDate;
                this.$store.commit('setLibraryOrder', libraryOrder);
                this.$store.commit('setLoadingModal', false);
                return;
              }
            }
          },

          completionEnabled(item) {
            let libraryOrderAllowedPeriod = this.$store.getters.homePageInformation.libraryOrderAllowedPeriod;
            let activeYear = this.$store.getters.activeYear;

            if (libraryOrderAllowedPeriod && item.year == activeYear && item.status == 'Pending')
              return true;
            return false;
          },

          completeLibraryOrder() {
            this.$store.commit('setActionLibraryModal', false);
            let token = utils.getLocalStorage('token');
            if (token != null) {
              this.$store.commit('setLoadingModal', true);
              request.completeLibraryOrder(token, this.libraryObject.id, this.pin,  this.completeLibraryOrderCallBack, () => this.completeOrderDialog = false);
            } else {
              this.$store.commit('setloginModal', true);
            }
          },

          completeLibraryOrderCallBack(response) {
            this.updateDataTable(response);
          },

            //select distPoint for report
            selectInstitutionForReport(){

                if (this.dialogm1 != '') {
                    this.e1 = 2;
                }
            },

            //return the step name
            returnStepName(n) {

                if (n == 1) {
                    return 'Ιδρύματα'
                }
                return 'Ημερολόγιο'
            },

            openDatePicker(all) {

                this.dates=[];
                this.ordersOrDeliveries = all;
                // var year = this.academicYearSelect.value;

                // this.dialogm1 = '';
                // this.dates = [];
                this.maxDate = utils.createPickerCurrentDate();
                this.datePicker = true;

                // var token = utils.getLocalStorage('token');
                // if (token != null) {
                //     this.$store.commit('setLoadingModal', true);
                //     request.getInstitution(token, year, this.getInstitutionCallBack);
                // } else {
                //     this.$store.commit('setloginModal', true);
                // }
            },

            getInstitutionCallBack(response){

                this.$store.commit('setLoadingModal', false);
                if (response.length > 0) {
                    var allInstitutions = {
                        id: -1,
                        name: 'ΟΛΑ'
                    };

                    response.splice(0, 0, allInstitutions);
                }
                this.institution = response;
                this.e1 = 1;
                this.dialogm1 = '';
                this.dates = [];
                this.maxDate = utils.createPickerCurrentDate();
                this.datePicker = true;
            },

            getReportPdf() {

                if (this.ordersOrDeliveries) {
                    this.dates = utils.sortDatesArray(this.dates);
                    service.startServicePublisherLibraryOrdersPdf(this.dates, -1);
                }
                else {
                    this.dates = utils.sortDatesArray(this.dates);
                    service.startServicePublisherLibraryOrdersDeliveredPdf(this.dates, -1);
                }
            },

            getReportXlsx() {
                if (this.ordersOrDeliveries) {
                    this.dates = utils.sortDatesArray(this.dates);
                    service.startServicePublisherLibraryOrdersXlsx(this.dates, -1);
                }
                else {
                    this.dates = utils.sortDatesArray(this.dates);
                    service.startServicePublisherLibraryOrdersDeliveredXlsx(this.dates, -1);
                }
            },

            getReport(type) {

                if (this.ordersOrDeliveries) {
                    //    get from orders Reports
                    if (this.dialogm1 == -1) {
                    //    get all report

                    }
                    else {
                    }
                } else {
                    //    get report from deliveries dist Point
                    if (this.dialogm1 == -1) {
                        //get all reports
                    }
                    else {
                    }
                }
                this.datePicker = false;
            },

            status(status) {

                if (status == "Completed") {
                    return 'Ολοκληρώθηκε'
                }
                return 'Προετοιμασία για Αποστολή'
            },

            //get info of library
            getinfo(item) {

                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    request.getLibraryDetails(token, item.id, this.getLibraryDetailsCallBack)
                } else {
                    this.$store.commit('setloginModal', true);
                }
            },

            getLibraryDetailsCallBack(response) {

                this.libraryInfoObject = response;
                this.$store.commit('setLoadingModal', false);
                this.$store.commit('setLibraryInfoModal', true);
            },

            //    get all library data with year
            getAllLibraryOrder(onChange) {

                var setYear = 0;
                if (onChange) {
                    setYear = this.academicYearSelect.value;
                } else {
                    var years = this.$store.getters.years;
                    if (years.length > 0) {
                        setYear = years[0].value;
                    }
                }

                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    request.getLibraryOrder(token, setYear, this.getLibraryOrderCallBack)
                } else {
                    this.$store.commit('setloginModal', true);
                }
            },

            getLibraryOrderCallBack(response) {

                var years = this.$store.getters.years;

                if (Object.keys(this.academicYearSelect).length < 1) {
                    if (years.length > 0) {
                        this.academicYearSelect = years[0];
                    }
                }
                this.$store.commit('setLibraryOrder', response);
                this.$store.commit('setLoadingModal', false);
            },

            libraryOrder() {

            },

            distPointAvailabilityOnSelectChange() {

                var distributionPointId = this.distPointSelect.id;
                var year = this.academicYearSelect.value;

                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    request.getdistributionPointAvailability(token, distributionPointId, year, this.getdistributionPointAvailabilityCallBack);
                } else {
                    this.$store.commit('setloginModal', true);
                }
            },

            returnTheDate(year) {

                var date = new Date(year).toLocaleDateString();
                return utils.formatDatesCustom(date);
            },

            createSelectItems() {

                this.selectItems = [];
                this.selectItems = this.$store.getters.years.slice();
                // this.selectItems.shift();
                this.getAllLibraryOrder(false);
            },

        },

        watch: {
            steps(val) {
                if (this.e1 > val) {
                    this.e1 = val
                }
            },
        },

        created() {
            window.scrollTo(0, 0);
            this.createSelectItems();
        }
    }
</script>


<style scoped>

</style>